import { __exports as keyCodes } from '../../../../../_virtual/key-codes.js';

var hasRequiredKeyCodes;

function requireKeyCodes () {
	if (hasRequiredKeyCodes) return keyCodes;
	hasRequiredKeyCodes = 1;

	Object.defineProperty(keyCodes, "__esModule", {
	  value: true
	});
	/** @ignore */
	keyCodes.DOWN_ARROW = 40;

	/** @ignore */
	keyCodes.LEFT_ARROW = 37;

	/** @ignore */
	keyCodes.RIGHT_ARROW = 39;

	/** @ignore */
	keyCodes.UP_ARROW = 38;
	
	return keyCodes;
}

export { requireKeyCodes as __require };
